export default __webpack_public_path__ + "static/media/reports.1d18deaa.svg";